import { render, staticRenderFns } from "./UniversityDivisionIndex.vue?vue&type=template&id=441d2bde&scoped=true&"
import script from "./UniversityDivisionIndex.vue?vue&type=script&lang=js&"
export * from "./UniversityDivisionIndex.vue?vue&type=script&lang=js&"
import style0 from "./UniversityDivisionIndex.vue?vue&type=style&index=0&id=441d2bde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441d2bde",
  null
  
)

export default component.exports